var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 67.11 68.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #231916;\n        font-family: HiraginoSans-W6-83pv-RKSJ-H, 'Hiragino Sans';\n        font-size: 35.5px;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #231916;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 4.05px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u30D9\\u30FC\\u30B9",
    "data-name": "\\u30D9\\u30FC\\u30B9"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(14.63 46.44)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uFF1F")), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m65.08,66.87l-6.59-17.15c3.21-4.86,5.1-10.66,5.1-16.92,0-17-13.78-30.78-30.78-30.78S2.03,15.81,2.03,32.81s13.78,30.78,30.78,30.78c4.65,0,9.01-1.11,12.96-2.95l19.31,6.23Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionIcon);
export default __webpack_public_path__ + "static/media/question_icon.bea7231c672783c5a201c1f04ad77350.svg";
export { ForwardRef as ReactComponent };